(function () {

  'use strict';

  eclipseApp.controller('promptRelinkAccountCtrl',
    ['$scope', 'commonService', '$modalInstance', '$translate', 'uteEndpoint', '$http', '$timeout', '$window', 'janrainService', 'util', 'env', 'userService', '$state', '$localStorage',
      function ($scope, commonService, $modalInstance, $translate, uteEndpoint, $http, $timeout, $window, janrainService, util, env, userService, $state, $localStorage) {
        $scope.popupClosewithMessage = function () {
          $modalInstance.close($scope);
        };

        $scope.linkAccountSuccess = function () {
          $localStorage.$default({
            promptRelinkAccount: true
          });

          var userInfo = {
            uuid: janrain.capture.ui.getProfileCookieData('uuid'),
            userID: janrain.capture.ui.getProfileCookieData('userID')
          };
          userInfo.firstName = '';
          userInfo.lastName = '';
          userInfo.isAccountLinked = false;
          userService.login(userInfo);
          $state.go('linkAccounts');
        };


        /* close icon on top of the pop up */
        $scope.cancel = function (triggerClose) {
          $modalInstance.close($scope);
          var redirectToState = '';
          var redirectToURL = '';

          if (env.fidoHomePageUrl) {
            redirectToURL = env.fidoHomePageUrl;
          } else {
            redirectToState = 'login';
          }

          console.log('redirectToState', redirectToState);
          console.log('redirectToURL', redirectToURL);

          commonService.logOutUser(false, '', redirectToState);
        };
      }]);
  /* registration QA/pass form has been submitted -- ends here */

})();
